import React, { useState, useEffect, useMemo } from "react"
// import { UserGrouping } from "./UserGrouping"
import { useUIContext } from "../UIContext"
import {
	DataGrid,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarDensitySelector,
	GridOverlay,
	useGridApiContext,
	useGridRootProps
} from "@mui/x-data-grid"
import { useSelector, shallowEqual } from "react-redux"
import { OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap"
import { makeStyles } from "@material-ui/core"
import { Pagination } from "@material-ui/lab"
import { BiEditAlt } from "react-icons/bi"
import { Button } from "../../../../_partials/Button"
import CheckIcon from "@material-ui/icons/Check"
import WarningIcon from "@material-ui/icons/Warning"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers"
import inventoryFiltersIcon from "../../../../../app/assets/ck-icons/inventory-filters-icon.svg"
import EditInventoryModelsModal from "./EditInventoryModelsModal"
import "../Inventory.css"
import DeleteInventoryModelsModal from "./DeleteInventoryModelsModal"
import { filterBySearchString } from "../../../Admin/manage-customer/UIHelpers"
import { ProgressBar } from "../../../../../_metronic/layout/components/extras/ProgressBar"

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		border: "none",
		"& .MuiPagination-root makeStyles-root-130": {
			width: "100%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		},

		"& .MuiDataGrid-cell:focus": {
			outline: "none"
		},
		"& .MuiDataGrid-selectedRowCount": {
			display: "none"
		},
		"& .MuiDataGrid-colCell": {
			minWidth: "0" // Ensure that minWidth is set to 0 to allow percentage width
		},
		"& .MuiDataGrid-columnSeparator": {
			opacity: 0
		},
		"& .MuiDataGrid-root .MuiDataGrid-columnHeaderTitle": {
			fontWeight: 600,
			fontSize: "1rem",
			color: "#4a4a68"
		},
		"& .MuiDataGrid-cell.row-cell .MuiDataGrid-cell--textLeft": {
			fontSize: "14px",
			fontWeight: 500
		},
		"& .MuiDataGrid-columnHeaderTitleContainer": {
			paddingLeft: 0,
			paddingRight: 0
		},
		"& .MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {
			paddingRight: "0px",
			paddingLeft: "10px"
		},
		"& .hide-scrollbar .MuiDataGrid-scrollbar": {
			display: "none"
		},
		"& .MuiDataGrid-root .MuiDataGrid-cell--textLeft": {
			paddingLeft: "2px"
		},

		"& .MuiDataGrid-cell.row-cell .MuiDataGrid-cell--withRenderer .MuiDataGrid-cell--textLeft": {
			maxHeight: "65px !important",
			minHeight: "65px !important"
		},
		"& .MuiPagination-root": {
			width: "100%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		},
		"& .MuiPaginationItem-root": {
			borderRadius: "3px !important",
			color: "#3077d3 !important",
			padding: "0 !important",
			margin: "-1px !important",
			border: "1px solid #f4f8fe !important"
		},

		"& .MuiPaginationItem-textPrimary.Mui-selected": {
			color: "#fff !important",
			border: "none"
		},
		"& .MuiDataGrid-root .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon, & .MuiDataGrid-root .MuiDataGrid-filterIcon, & .MuiDataGrid-root .MuiDataGrid-sortIcon":
			{
				color: "#3077d3"
			},
		"& .MuiDataGrid-root .MuiDataGrid-viewport": {
			minHeight: "700px",
			maxHeight: "none"
		},
		"& .MuiDataGrid-renderingZone": {
			maxHeight: "none"
		},
		"& .MuiDataGrid-root .MuiDataGrid-footerContainer": {
			minHeight: "90px !important"
		}
	}
}))

export default function ModelsInventoryTable({
	filterTypeOptions,
	filterVendorOptions,
	filterFeaturesOptions,
	filterNodeTypeOptions,
	filterChipsetOptions,
	filterBatteryOptions,
	technology,
	rows,
	setRows,
	searchText,
	setSearchText
}) {
	// ━━━━━━━━━━━━━  useUIContext  ━━━━━━━━━━━━━ \\
	const UIContext = useUIContext()
	const UIProps = useMemo(() => {
		return {
			ids: UIContext.idsInventoryModels,
			setIds: UIContext.setIdsInventoryModels,
			setTechnology: UIContext.setTechnology,
			openDeleteInventoryModelsModal: UIContext.openDeleteInventoryModelsModal,
			setCurrentModelsTablePageInfo: UIContext.setCurrentModelsTablePageInfo,
			setRowsToUseModelsTable: UIContext.setRowsToUseModelsTable,
			setColumnVisibilityModelModelsTable: UIContext.setColumnVisibilityModelModelsTable,
			columnVisibilityModelModelsTable: UIContext.columnVisibilityModelModelsTable
		}
	}, [UIContext])

	// ━━━━━━━━━━━━━  Selectors  ━━━━━━━━━━━━━ \\
	const { modelsInventory, listLoading, floorPlans } = useSelector(
		state => ({
			modelsInventory: state.inventory.modelsInventory,
			listLoading: state.inventory.listLoading,
			floorPlans: state.basePage.floorPlans
		}),

		shallowEqual
	)

	// ━━━━━━━━━━━━━  useState  ━━━━━━━━━━━━━ \\
	const [page, setPage] = useState(0)
	const [pageSize, setPageSize] = useState(10)
	const [activeFilters, setActiveFilters] = useState(false)
	const [searchedRows, setSearchedRows] = useState(null)
	const [selectionModel, setSelectionModel] = useState([])
	const [showEditModal, setShowEditModal] = useState(false)
	const [showDeleteModel, setShowDeleteModal] = useState(false)
	const [rowsToUse, setRowsToUse] = useState([])
	const [currentRows, setCurrentRows] = useState([])
	const [rowCounter, setRowCounter] = useState(0)
	const [rowCountState, setRowCountState] = useState(rowCounter)
	const [sortModel, setSortModel] = useState([
		{
			field: "name",
			sort: "asc"
		}
	])
	const classes = useStyles()
	// ━━━━━━━━━━━━━  useEffect  ━━━━━━━━━━━━━ \\
	useEffect(() => {
		if (!modelsInventory || !modelsInventory.length > 0 || !technology) return

		let unfilteredModels = modelsInventory
		unfilteredModels =
			unfilteredModels &&
			unfilteredModels.length > 0 &&
			unfilteredModels.map((model, index) => {
				return { ...model }
			})

		if (
			!filterTypeOptions ||
			!filterVendorOptions ||
			!filterFeaturesOptions ||
			!filterNodeTypeOptions ||
			!filterChipsetOptions ||
			!filterBatteryOptions
		)
			return

		const anyFilterActive =
			filterTypeOptions.find(filter => filter.selected) ||
			filterVendorOptions.find(filter => filter.selected) ||
			filterFeaturesOptions.find(filter => filter.selected) ||
			filterNodeTypeOptions.find(filter => filter.selected) ||
			filterChipsetOptions.find(filter => filter.selected) ||
			filterBatteryOptions.find(filter => filter.selected)

		let filteredRows = null
		if (anyFilterActive) {
			setActiveFilters(true)

			filteredRows = unfilteredModels.filter(
				node =>
					filterTypeOptions.find(filter => filter.node === node.type && filter.selected) ||
					filterVendorOptions.find(filter => filter.node === node.vendor && filter.selected) ||
					filterFeaturesOptions.find(
						filter => filter.node === node.features && filter.selected
					) ||
					filterNodeTypeOptions.find(
						filter => filter.node === node.nodeType && filter.selected
					) ||
					filterChipsetOptions.find(
						filter => filter.node === node.chipset && filter.selected
					) ||
					filterBatteryOptions.find(
						filter => filter.node === node.battery.toString() && filter.selected
					)
			)
			setRows(filteredRows)
		} else {
			setActiveFilters(false)
			setRows(unfilteredModels)
		}
	}, [
		modelsInventory,
		filterTypeOptions,
		filterFeaturesOptions,
		filterVendorOptions,
		filterNodeTypeOptions,
		filterChipsetOptions,
		filterBatteryOptions,
		technology,
		floorPlans
	])

	//search logic with filterBySearchString
	useEffect(() => {
		if (!rows) return

		if (!searchText && searchText.trim() == "") setSearchedRows(filteredRows)
		// return

		const fieldsToSearch = ["battery", "chipset", "name", "nodeType", "type", "vendor"] // Define the fields to search
		const filteredRows = filterBySearchString(rows, searchText, fieldsToSearch)

		if (filteredRows && filteredRows.length > 0) {
			setSearchedRows(filteredRows)
		} else {
			setSearchedRows([])
		}
	}, [rows, searchText])

	//rowsToUse is responsible for saving the data state when ever a new data filters appears
	//this means on searching, sorting, filtering or hiding rowsToUse will always have all data
	useEffect(() => {
		if (!rows && !searchedRows) return

		if (searchedRows) {
			setRowsToUse(searchedRows)
		} else if (rows && rows.length > 0) {
			setRowsToUse(rows)
		}
	}, [rows, searchedRows])

	//currentRows is responsible for keeping track of the current rows the user is viewing
	//directly connect to page and pageSize for selection rows to be working properly
	useEffect(() => {
		updateCurrentRows()
		UIProps.setCurrentModelsTablePageInfo({ page: page, pageSize: pageSize })
	}, [rowsToUse, page, pageSize])

	//this controlers the rowsCount prop from data grid
	//it enables to change page and page size and keep track of past selected rows and "select all" only for current page
	useEffect(() => {
		setRowCountState(prevRowCountState =>
			rowCounter !== undefined ? rowCounter : prevRowCountState
		)
	}, [rowCounter])

	// ━━━━━━━━━━━━━  handlers  ━━━━━━━━━━━━━ \\
	// Update the handleSortModelChange function in your PeopleTable component
	const handleSortModelChange = newSortModel => {
		// Sort the full dataset (rowsToUse) based on the sort model
		const sortedRows = [...rowsToUse].sort((a, b) => {
			// Iterate over the sort model
			for (const sortItem of newSortModel) {
				const field = sortItem.field
				const sortOrder = sortItem.sort === "asc" ? 1 : -1 // Only consider asc and desc
				if (sortItem.sort !== null) {
					if (field === "disabled") {
						// Sort based on boolean value for the "disabled" field
						if (a[field] && !b[field]) return sortOrder
						if (!a[field] && b[field]) return -sortOrder
						continue // Move to the next sort item
					}
					// For other fields, handle sorting based on their type
					if (a[field] === null && b[field] === null) continue // If both values are null, maintain current order
					if (a[field] === null) return -sortOrder // If 'a' is null, place it before 'b'
					if (b[field] === null) return sortOrder // If 'b' is null, place it before 'a'
					// Sort non-null values based on column type
					if (typeof a[field] === "string") {
						const comparison = a[field].localeCompare(b[field], undefined, { numeric: true })
						if (comparison !== 0) return comparison * sortOrder
					} else if (typeof a[field] === "number") {
						return (a[field] - b[field]) * sortOrder
					}
				}
			}
			return 0 // If no column has a defined sort order, maintain current order
		})

		// Update the sorted data and currentRows
		setRowsToUse(sortedRows) //all data
		setCurrentRows(sortedRows.slice(page * pageSize, (page + 1) * pageSize))
		setSortModel(newSortModel)
	}
	// Function to update the current rows based on the current page and page size
	const updateCurrentRows = () => {
		const startIndex = page * pageSize
		const endIndex = Math.min(startIndex + pageSize, rowsToUse.length)
		const newCurrentRows = rowsToUse.slice(startIndex, endIndex)
		setCurrentRows(newCurrentRows)
		setRowCounter(rowsToUse.length)
		UIProps.setRowsToUseModelsTable(rowsToUse) //for printing all data
		//UIProps.setRowsToUse(rowsToUse.slice(page * pageSize, (page + 1) * pageSize)) //data from current page and page size
	}

	const columns = [
		// {
		// 	field: "__check__",
		// 	headerName: "Checkbox selection",
		// 	width: 50,
		// 	minWidth: 50,
		// 	align: "center",
		// 	sortable: false,
		// 	filterable: false,
		// 	hideable: false
		// },
		{
			field: "actions",
			hideable: false,
			headerName: "Actions",
			renderCell: params => {
				const row = params.row
				return (
					<div data-testid="actions-cell">
						<>
							<OverlayTrigger
								placement="bottom"
								overlay={<Tooltip id="firebase-Edit-tooltip">Edit Model</Tooltip>}
							>
								<Button
									data-testid="edit_button"
									id={params.row.id}
									variant="text"
									onClick={() => {
										UIProps.setIds([params.row.id])
										setSelectionModel([params.row.id])
										setShowEditModal(true)
									}}
									startIcon={<BiEditAlt color="#2673F0" />}
								/>
							</OverlayTrigger>
							<OverlayTrigger
								placement="bottom"
								overlay={
									<Tooltip id="firebase-Edit-tooltip">Delete Selected Models</Tooltip>
								}
							>
								<Button
									variant="contained"
									color="errorLight"
									className="MUICustom_secondary"
									style={{
										marginLeft: "1rem",
										borderRadius: "5px",
										maxWidth: "34px",
										minWidth: "34px",
										height: "33px"
									}}
									startIcon={
										<SVG
											className="MUICustom_secondary_svg"
											src={toAbsoluteUrl("/media/svg/icons/General/trash2.svg")}
										/>
									}
									onClick={() => {
										UIProps.setIds([params.row.id])
										setSelectionModel([params.row.id])
										setShowDeleteModal(true)
									}}
									data-testid="unassign-button"
								/>
							</OverlayTrigger>
						</>
					</div>
				)
			},
			editable: false
		},
		{
			field: "name",
			headerName: "Name",
			hideable: false,
			type: "string",
			minWidth: 150,
			hideable: false
			// description: "Test Description usage on mui data grid"
		},
		{
			field: "vendor",
			headerName: "Vendor",
			type: "string",
			minWidth: 150
		},
		{
			field: "nodeType",
			headerName: "Node Type",
			type: "string",
			minWidth: 150,
			renderCell: params => {
				const { nodeType, sinks } = params.row

				if (sinks && nodeType == "gateway") {
					return (
						<OverlayTrigger
							placement="bottom"
							overlay={<Tooltip id="firebase-notification-tooltip">Sinks: {sinks}</Tooltip>}
						>
							<span>{nodeType}</span>
						</OverlayTrigger>
					)
				}
				return <span>{nodeType}</span>
			}
		},
		{
			field: "type",
			headerName: "type",
			type: "string",
			minWidth: 150,
			renderCell: params => {
				const { type, nodeType } = params.row

				if (!type && nodeType == "gateway") {
					return <span>-</span>
				}
				return <span>{type}</span>
			}
		},
		{
			field: "battery",
			headerName: "Battery",
			type: "string",
			minWidth: 150
		},
		{
			field: "chipset",
			headerName: "Chipset",
			type: "string",
			minWidth: 150
		},
		{
			field: "features.led",
			headerName: "LED",
			type: "string",
			width: 100,
			renderCell: params => {
				return params.row?.features?.led || 0
			}
		},
		{
			field: "ipProtection",
			headerName: "Ip Protection",
			type: "string",
			width: 150,
			renderCell: params => {
				return params.row?.ipProtection || ""
			}
		},
		{
			field: "features.button",
			headerName: "Button",
			type: "boolean",
			width: 100,
			renderCell: params => {
				return params.row?.features?.button ? (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CheckCircle.svg")} />
				) : (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CrossCircle.svg")} />
				)
			}
		},
		{
			field: "features.buzzer",
			headerName: "Buzzer",
			type: "boolean",
			width: 100,
			renderCell: params => {
				return params.row?.features?.buzzer ? (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CheckCircle.svg")} />
				) : (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CrossCircle.svg")} />
				)
			}
		},
		{
			field: "features.motion",
			headerName: "Motion",
			type: "boolean",
			width: 100,
			renderCell: params => {
				return params.row?.features?.motion ? (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CheckCircle.svg")} />
				) : (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CrossCircle.svg")} />
				)
			}
		},
		{
			field: "features.nfc",
			headerName: "NFC",
			type: "boolean",
			width: 100,
			renderCell: params => {
				return params.row?.features?.nfc ? (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CheckCircle.svg")} />
				) : (
					<SVG src={toAbsoluteUrl("/media/svg/icons/General/CrossCircle.svg")} />
				)
			}
		}
	]

	return (
		<div style={{ width: "100%" }} data-testid="ModelsInventoryTable">
			<div className="row justify-content-end text-end">
				<span className="selected-filters-title">Selected filters</span>
			</div>
			<div className="row mb-5" style={{ marginRight: "2px" }}>
				{/* <div className="selected-actions col align-self-end">
					<UserGrouping setSelectionModel={setSelectionModel} />
				</div> */}
				{/* //TODO list selected filters options */}
				<div
					className="col d-flex flex-wrap-reverse justify-content-end pr-0"
					style={{
						maxHeight: "75px",
						overflow: "auto"
					}}
				>
					{!activeFilters && (
						<div>
							<div className="no-selected-filters">
								<span>
									NO SELECTED FILTERS <img src={inventoryFiltersIcon} />
								</span>
							</div>
						</div>
					)}
					{filterTypeOptions &&
						filterTypeOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}

					{filterFeaturesOptions &&
						filterFeaturesOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}
					{filterVendorOptions &&
						filterVendorOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}
					{filterNodeTypeOptions &&
						filterNodeTypeOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}
					{filterBatteryOptions &&
						filterBatteryOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}
					{filterChipsetOptions &&
						filterChipsetOptions.map(type => {
							if (type.selected) {
								return (
									<div className="selected-filters" key={type.node}>
										<span>
											{type.node} <CheckIcon className="selected-filters-icon" />
										</span>
									</div>
								)
							}
						})}
				</div>
			</div>
			{listLoading && <ProgressBar.LinearIndeterminate />}
			<DataGrid
				style={{
					fontFamily: "Poppins",
					fontWeight: 400,
					fontSize: "13px",
					border: "none",
					width: "100%",
					color: "#464e5f"
				}}
				rows={currentRows}
				columns={columns}
				className={classes.root}
				density="standard"
				disableExtendRowFullWidth={true}
				pagination
				disableSelectionOnClick
				loading={listLoading || !technology}
				disableColumnMenu={true}
				// checkboxSelection
				components={{
					Toolbar: QuickToolbar,
					Pagination: props => <CustomPagination {...props} rows={rows} />,
					NoRowsOverlay: technology ? CustomNoRowsOverlay : CustomNoTechnologyOverlay
				}}
				rowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
				page={page}
				onPageChange={newPage => {
					setPage(newPage)
				}}
				pageSize={pageSize}
				onPageSizeChange={e => {
					setPageSize(e)
				}}
				autoHeight
				rowCount={rowCountState}
				//* to selected only current page rows
				paginationMode="server"
				onSelectionModelChange={newSelectionModel => {
					UIProps.setIds(newSelectionModel)
					setSelectionModel(newSelectionModel)
				}}
				selectionModel={selectionModel}
				keepNonExistentRowsSelected //* to be able to change page and keep selected rows
				//* for printing with matching table order
				sortingOrder={["desc", "asc"]}
				sortModel={sortModel}
				onSortModelChange={handleSortModelChange}
				//* for printing only visible columns
				onColumnVisibilityModelChange={e => {
					UIProps.setColumnVisibilityModelModelsTable(e)
				}}
				columnVisibilityModel={UIProps.columnVisibilityModelModelsTable}
			/>
			<EditInventoryModelsModal
				showEditModal={showEditModal}
				setShowEditModal={setShowEditModal}
				technology={technology}
				setSelectionModel={setSelectionModel}
			/>
			<DeleteInventoryModelsModal
				showDeleteModel={showDeleteModel}
				setShowDeleteModal={setShowDeleteModal}
				technology={technology}
				setSelectionModel={setSelectionModel}
			/>
		</div>
	)
}

function CustomPagination({ rows }) {
	const apiRef = useGridApiContext()
	const state = apiRef.current.state
	const rootElement = apiRef.current.rootElementRef
	const rootProps = useGridRootProps()
	const classes = useStyles()
	const options = [5, 10, 20, 30, 50, 100]

	const handlePageSizeChange = pageSize => {
		apiRef.current.setPageSize(pageSize)
	}

	return (
		<>
			<Dropdown>
				<Dropdown.Toggle variant="light" id="dropdown-basic">
					{state.pagination.pageSize}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{options.map(option => {
						return (
							<Dropdown.Item
								key={option}
								as="button"
								onClick={() => handlePageSizeChange(option)}
							>
								{option}
							</Dropdown.Item>
						)
					})}
				</Dropdown.Menu>
			</Dropdown>

			<Pagination
				className={classes.root}
				id="custom-pagination"
				color="primary"
				count={state.pagination.pageCount}
				page={state.pagination.page + 1}
				onChange={(event, value) => apiRef.current.setPage(value - 1)}
			/>

			<span style={{ minWidth: "110px" }}>Total Rows: {(rows && rows?.length) || 0}</span>
		</>
	)
}

function QuickToolbar(props) {
	return (
		<div>
			<GridToolbarContainer>
				<GridToolbarColumnsButton />
				{/* <GridToolbarFilterButton /> */}
				<GridToolbarDensitySelector />
			</GridToolbarContainer>
		</div>
	)
}

function CustomNoRowsOverlay() {
	return (
		<GridOverlay>
			<div>No Rows</div>
		</GridOverlay>
	)
}

function CustomNoTechnologyOverlay() {
	return (
		<GridOverlay>
			<div className="overlay-modal-no-technology">
				<div className="row" style={{ marginLeft: "10px" }}>
					<div className="col">
						<div className="row overlay-modal-no-technology-title">
							<WarningIcon style={{ marginRight: "10px" }} />
							No data to display
						</div>
					</div>
				</div>
				<div className="row" style={{ marginLeft: "10px" }}>
					<div className="col">
						<div className="row overlay-modal-no-technology-text">
							Please select the technology in order to be provided with more information.{" "}
						</div>
					</div>
				</div>
			</div>
		</GridOverlay>
	)
}
